import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RecommendationCardActionsComponent } from './recommendation-card-actions/recommendation-card-actions.component';
import { RecommendationCardCoverComponent } from './recommendation-card-cover/recommendation-card-cover.component';
import { RecommendationCardFeatureComponent } from './recommendation-card-feature/recommendation-card-feature.component';
import { RecommendationCardIconComponent } from './recommendation-card-icon/recommendation-card-icon.component';
import { RecommendationCardMediaComponent } from './recommendation-card-media/recommendation-card-media.component';
import { RecommendationCardStaticComponent } from './recommendation-card-static/recommendation-card-static.component';
import { RecommendationCardTagComponent } from './recommendation-card-tag/recommendation-card-tag.component';
import { RecommendationCardTextComponent } from './recommendation-card-text/recommendation-card-text.component';
import { RecommendationCardTitleComponent } from './recommendation-card-title/recommendation-card-title.component';
import { RecommendationCardComponent } from './recommendation-card.component';
import { VpgrooveModule } from '@engineering/vpgroove-angular';
import { GenesisPipesModule } from '@genesis-frontend/genesis-utilities';

@NgModule({
    declarations: [
        RecommendationCardComponent,
        RecommendationCardActionsComponent,
        RecommendationCardTitleComponent,
        RecommendationCardFeatureComponent,
        RecommendationCardTagComponent,
        RecommendationCardTextComponent,
        RecommendationCardMediaComponent,
        RecommendationCardIconComponent,
        RecommendationCardCoverComponent,
        RecommendationCardStaticComponent
    ],
    imports: [CommonModule, VpgrooveModule, GenesisPipesModule],
    exports: [
        RecommendationCardComponent,
        RecommendationCardActionsComponent,
        RecommendationCardTitleComponent,
        RecommendationCardFeatureComponent,
        RecommendationCardTagComponent,
        RecommendationCardTextComponent,
        RecommendationCardMediaComponent,
        RecommendationCardIconComponent,
        RecommendationCardCoverComponent,
        RecommendationCardStaticComponent
    ]
})
export class RecommendationCardModule {}
